import { HIDE_BOOKING_DETAILS } from "./types";

const hideBookingDetails = () => ({
  type: HIDE_BOOKING_DETAILS,
});

export default hideBookingDetails;
